import styled from "styled-components";

export const AssignmentManagementWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  max-width: 1100px;
  margin: 0 auto;

  .assignment-builder,
  .assignments-list-panel,
  .assignments-empty-state,
  .assignment-card,
  .assignment-step {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    box-shadow: 0 18px 42px rgba(32, 51, 46, 0.06);
  }

  .assignment-builder {
    padding: 1.25rem;
  }

  .assignment-view-actions {
    display: flex;
    justify-content: flex-end;
  }

  .tracking-view-actions {
    margin-bottom: 0.85rem;
  }

  .assignment-view-btn {
    min-height: 40px;
    border: 1px solid #1d6257;
    border-radius: 8px;
    background: #1d6257;
    color: #ffffff;
    cursor: pointer;
    font-weight: 900;
    padding: 0.5rem 0.9rem;
  }

  .assignment-view-btn.ghost {
    background: #eef6f3;
    color: #1d6257;
  }

  .assignment-builder h2,
  .assignments-list-panel h2,
  .assignment-step h3,
  .assignment-card h3,
  .assignments-empty-state h2 {
    margin: 0.35rem 0;
    color: #17342f;
    letter-spacing: 0;
    text-transform: none;
  }

  .assignment-builder-form {
    display: grid;
    gap: 0.9rem;
    margin-top: 0.85rem;
  }

  .assignment-step {
    padding: 1rem;
  }

  .assignment-content-grid,
  .assignment-student-grid {
    display: grid;
    gap: 0.6rem;
    margin-top: 0.75rem;
  }

  .assignment-content-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .assignment-content-card,
  .assignment-student-card {
    border: 1px solid #d6e2de;
    border-radius: 8px;
    background: #fbfdfc;
    cursor: pointer;
    text-align: left;
  }

  .assignment-content-card {
    display: grid;
    gap: 0.5rem;
    padding: 0.65rem;
  }

  .assignment-content-select {
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    width: 100%;
    text-align: left;
    cursor: pointer;
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 0.7rem;
  }

  .assignment-content-card.selected,
  .assignment-student-card.selected {
    border-color: #247467;
    box-shadow: 0 0 0 3px rgba(36, 116, 103, 0.14);
  }

  .assignment-content-cover {
    width: 72px;
    height: 92px;
    border-radius: 8px;
    background: #edf4f1;
    color: #2f5850;
    display: grid;
    place-items: center;
    overflow: hidden;
  }

  .assignment-content-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .assignment-content-copy {
    min-width: 0;
    display: grid;
    gap: 0.2rem;
    color: #60716d;
    font-size: 0.84rem;
  }

  .assignment-content-copy strong {
    color: #1d3832;
    font-size: 0.95rem;
  }

  .assignment-preview-link {
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    text-align: left;
    cursor: pointer;
    color: #1d6257;
    font-weight: 900;
    font-size: 0.8rem;
  }

  .assignment-student-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .assignment-student-card {
    display: grid;
    gap: 0.2rem;
    padding: 0.8rem;
    color: #60716d;
    font-size: 0.84rem;
  }

  .assignment-student-card strong {
    color: #1d3832;
    font-size: 0.95rem;
  }

  .assignment-step-actions {
    display: flex;
    justify-content: flex-start;
    margin-top: 0.7rem;
  }

  .assignment-display-all-btn {
    min-height: 38px;
    border: 1px solid #1d6257;
    border-radius: 8px;
    background: #eef6f3;
    color: #1d6257;
    cursor: pointer;
    font-weight: 900;
    padding: 0.45rem 0.8rem;
  }

  .assignment-sheet-overlay {
    position: fixed;
    inset: 0;
    z-index: 12;
    background: rgba(15, 25, 23, 0.46);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 1rem;
  }

  .assignment-sheet {
    width: min(920px, 100%);
    max-height: calc(100vh - 1.5rem);
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 14px 14px 0 0;
    box-shadow: 0 -16px 40px rgba(32, 51, 46, 0.18);
    overflow: hidden;
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    animation: assignmentSheetUp 0.2s ease-out;
  }

  .assignment-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.9rem 1rem;
    border-bottom: 1px solid #e3ece8;
  }

  .assignment-sheet-header h3 {
    margin: 0;
    color: #17342f;
  }

  .assignment-sheet-close {
    border: 0;
    background: transparent;
    color: #1d6257;
    cursor: pointer;
    font-weight: 900;
    padding: 0;
  }

  .assignment-sheet-body {
    overflow: auto;
    padding: 1rem;
    display: grid;
    gap: 0.75rem;
  }

  .assignment-preview-cover {
    width: min(220px, 100%);
  }

  .assignment-preview-cover img {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #dce5df;
  }

  .assignment-preview-meta {
    margin: 0;
    color: #49645e;
    font-weight: 700;
  }

  .assignment-preview-paragraphs {
    display: grid;
    gap: 0.5rem;
    margin: 0.2rem 0 0;
    padding-left: 1.2rem;
    color: #20332e;
  }

  @keyframes assignmentSheetUp {
    from {
      transform: translateY(16px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .assignment-config-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .assignment-config-grid .lms-field {
    display: grid;
    gap: 0.7rem;
  }

  .assignment-config-grid .lms-field span {
    display: inline-block;
  }

  .assignment-checkbox {
    grid-column: 1 / -1;
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    color: #26413b;
    font-weight: 800;
  }

  .assignment-checkbox input {
    width: 18px;
    height: 18px;
    accent-color: #247467;
  }

  .assignment-submit-row {
    display: flex;
    justify-content: flex-end;
  }

  .assignments-list-panel {
    padding: 1.25rem;
  }

  .assignments-list-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
  }

  .assignments-list-top .lms-field {
    display: grid;
    gap: 0.7rem;
    min-width: 240px;
  }

  .assignments-list-top .lms-field span {
    display: inline-block;
  }

  .assignments-list-top select {
    min-height: 40px;
    border: 1px solid #d4dfdb;
    border-radius: 8px;
    background: #fbfdfc;
    color: #17342f;
    font: inherit;
    font-weight: 700;
    padding: 0.5rem 0.7rem;
  }

  .assignments-list {
    display: grid;
    gap: 0.75rem;
    margin-top: 0.9rem;
  }

  .assignment-card {
    padding: 0.9rem;
  }

  .assignment-card header {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    align-items: flex-start;
    margin-bottom: 0.7rem;
  }

  .assignment-card header p {
    margin: 0;
    color: #60716d;
  }

  .assignment-facts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55rem;
    margin: 0;
  }

  .assignment-facts div {
    background: #f3f9f6;
    border-radius: 8px;
    padding: 0.55rem;
  }

  .assignment-facts dt {
    color: #60716d;
    font-size: 0.78rem;
    font-weight: 800;
  }

  .assignment-facts dd {
    margin: 0.1rem 0 0;
    color: #17342f;
    font-weight: 900;
  }

  .assignment-status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    border-radius: 999px;
    padding: 0 0.7rem;
    font-size: 0.78rem;
    font-weight: 900;
    letter-spacing: 0.04em;
  }

  .assignment-status-pending {
    background: #eef4ff;
    color: #2e5ea8;
  }

  .assignment-status-in_progress {
    background: #fff7e6;
    color: #a56b0a;
  }

  .assignment-status-completed {
    background: #ebf8f1;
    color: #1f7f50;
  }

  .assignment-status-overdue {
    background: #fff2f2;
    color: #b63b3b;
  }

  .assignments-empty-state {
    margin-top: 0.85rem;
    padding: 1rem;
  }

  .assignments-empty-state p,
  .assignments-hint,
  .assignments-loading {
    margin: 0;
    color: #60716d;
  }

  .assignments-error {
    border-radius: 8px;
    background: #fff5f5;
    color: #9f2f2f;
    font-weight: 800;
    margin: 0;
    padding: 0.65rem 0.8rem;
  }

  @media (max-width: 760px) {
    .assignment-content-grid,
    .assignment-student-grid,
    .assignment-config-grid,
    .assignment-facts {
      grid-template-columns: 1fr;
    }

    .assignments-list-top {
      flex-direction: column;
      align-items: stretch;
    }

    .assignment-view-actions {
      justify-content: stretch;
    }

    .assignment-view-btn {
      width: 100%;
    }

    .assignment-sheet-overlay {
      padding: 0;
    }

    .assignment-sheet {
      width: 100%;
      max-height: 90vh;
      border-radius: 16px 16px 0 0;
    }
  }
`;
